import { ref, watch, type Ref } from 'vue';

import type { SubNetworkRaw } from '@/api/ApiTypes';
import { useSubNetworksStore } from '@/stores/subNetworksStore';

type UseFrozenSubNetworks = {
	subNetworks: Ref<SubNetworkRaw[]>;
};

// Фиксирует список подсетей на момент их первой загрузки, чтобы подписи серий на графиках
// не менялись при последующих обновлениях стора.
const useFrozenSubNetworks = (): UseFrozenSubNetworks => {
	const subNetworksStore = useSubNetworksStore();
	const subNetworks = ref<SubNetworkRaw[]>([]);
	watch(() => subNetworksStore.subNetworks, (newSubNetworks, oldSubNetworks) => {
		if (newSubNetworks.length > 0 && (oldSubNetworks == null || oldSubNetworks.length === 0)) {
			subNetworks.value = newSubNetworks;
		}
	}, { immediate: true });
	return {
		subNetworks,
	};
};

export { useFrozenSubNetworks };
